export default __webpack_public_path__ + "static/media/wallpaperflare.com_wallpaper1.0998d3da.png";